import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};



const app = initializeApp(firebaseConfig);

/** Doit être la même région que le déploiement des onCall (ex. us-central1, europe-west1). */
export const firebaseFunctionsRegion =
  process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION || "us-central1";

export const db = getFirestore(app);
export const auth = getAuth(app);
export { app };